import React from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'react-bootstrap-5';

import ResultAndMapViewer from '../search/components/result_and_map_viewer';
import { selectCallListTableView } from '../store/selectors/ui';

type CallListMapViewProps = {
  nominatimUrl: string;
  lastUpdatedMap: Map<number, Date>;
}

export default function CallListMapView({
  nominatimUrl,
  lastUpdatedMap
}: CallListMapViewProps) {
  const showTableView = useSelector(selectCallListTableView);

  if (showTableView) {
    return null;
  }

  return (
    <Container className="d-flex flex-column flex-grow-1 overflow-hidden" fluid>
      <ResultAndMapViewer
        lastUpdatedMap={lastUpdatedMap}
        nominatimUrl={nominatimUrl}
      />
    </Container>
  );
}
